import { FormControl, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import FieldRenderer from './FieldRenderer';
import type { FieldSchema } from './types';

const ToggleGroupField = ({ field }: { field: FieldSchema }) => {
  const { handleChange } = useFormContext();
  const formData = useFormData();

  return (
    <Grid size={field.size || 12}>
      <Typography color="text.primary" variant="h6" sx={{ mb: 1 }}>
        {field.label}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={12}>
          <FormControl fullWidth>
            <ToggleButtonGroup
              value={formData[field.name!] || null}
              onChange={(_, value) => handleChange({ target: { name: field.name, value } }, field)}
              exclusive
              color="primary"
              fullWidth
            >
              {field.options?.map((option) => (
                <ToggleButton key={option.value} value={option.value}>
                  {option.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </FormControl>
        </Grid>
        {field.options?.map((option) =>
          formData[field.name!] && formData[field.name!] === option.value && option.fields ? (
            <Grid size={option.size || 12} key={option.value + '_form'}>
              <Grid container spacing={2}>
                {option.fields.map((subField, index) => (
                  <FieldRenderer key={subField.name || index} field={subField} />
                ))}
              </Grid>
            </Grid>
          ) : null,
        )}
      </Grid>
    </Grid>
  );
};

export default ToggleGroupField;
